export const BASE_DOMAINS_URL = '/v1/domains';

export const DOMAIN_CONFIG_URL = `${BASE_DOMAINS_URL}/:id/config`;
export const SET_PRIMARY_DOMAIN_URL = `${BASE_DOMAINS_URL}/:id/primary`;
export const UPDATE_OUR_DOMAIN_URL = `${BASE_DOMAINS_URL}/our_domain`;
export const DELETE_DOMAIN_URL = `${BASE_DOMAINS_URL}/:id`;
export const UPDATE_DOMAIN_STATUS_URL = `${BASE_DOMAINS_URL}/status`;
export const GET_DOMAIN_TO_UPDATE_URL = `${BASE_DOMAINS_URL}/check-migration`;
export const SET_DOMAIN_TO_NOTIFY_URL = `${BASE_DOMAINS_URL}/notify-migration`;
export const GET_HOSTNAME_DNS_VALUES_URL = `${BASE_DOMAINS_URL}/dns_values`;
export const GET_DOMAINS_ERRORS_URL = `${BASE_DOMAINS_URL}/errors`;
export const GET_DOMAIN_SUGGESTIONS_URL = `${BASE_DOMAINS_URL}/suggestions`;
export const CREATE_DOMAIN_ORDER_URL = `${BASE_DOMAINS_URL}/orders`;
export const GET_ACTIVE_DOMAIN_ORDER_URL = `${BASE_DOMAINS_URL}/orders/active`;
export const GET_DOMAIN_ORDER_URL = `${BASE_DOMAINS_URL}/orders/:payOrderId`;
export const UPDATE_DOMAIN_ORDER_CONTACT_URL = `${BASE_DOMAINS_URL}/orders/:payOrderId/contact`;
export const ACKNOWLEDGE_DOMAIN_ORDER_URL = `${BASE_DOMAINS_URL}/orders/:payOrderId/acknowledge`;
export const GET_DOMAIN_LIFECYCLE_DETAILS_URL = `${BASE_DOMAINS_URL}/:domain`;
export const RESEND_VERIFICATION_EMAIL_URL = `${BASE_DOMAINS_URL}/stores/:storeId/email-resend`;
export const GET_COUNTRIES_URL = `/v1/shipping/countries`;
export const GET_PROVINCES_URL = `/v1/shipping/provinces/:countryCode`;

export const domainsEndpoints = {
  getDomains: 'getDomains',
  getCountries: 'getCountries',
  getProvinces: 'getProvinces',
  updateDomainOrderContact: 'updateDomainOrderContact',
  createDomain: 'createDomain',
  deleteDomain: 'deleteDomain',
  updateOurDomain: 'updateOurDomain',
  getDomainConfig: 'getDomainConfig',
  setPrimaryDomain: 'setPrimaryDomain',
  updateDomainStatus: 'updateDomainStatus',
  getDomainSoftBlock: 'getDomainSoftBlock',
  setDomainToNotify: 'setDomainToNotify',
  getHostnameDnsValues: 'getHostnameDnsValues',
  getDomainsErrors: 'getDomainsErrors',
  getDomainSuggestions: 'getDomainSuggestions',
  createDomainOrder: 'createDomainOrder',
  getActiveDomainOrder: 'getActiveDomainOrder',
  getDomainOrder: 'getDomainOrder',
  acknowledgeDomainOrder: 'acknowledgeDomainOrder',
  getDomainLifecycleDetails: 'getDomainLifecycleDetails',
  resendVerificationEmail: 'resendVerificationEmail',
} as const;

export const domainsTags = {
  domainsList: 'domainsList',
  activeOrder: 'activeOrder',
} as const;
